import { TextButton } from '@twistopayments/design-system/components/atoms/button'
import type { Variants } from '@twistopayments/design-system/components/atoms/button/text-button/text-button.styles'
import { useRouter } from 'next/router'

import type { LinkUrl, LinksButtonComponent } from '@twisto/api-cms'

import { appendSearchParams, getLinkUrl } from 'homepage/utils'

type Props = {
  link: LinksButtonComponent
  increaseFontSize?: boolean
  variant?: Variants
}
export const Button = ({ link, increaseFontSize = false, variant }: Props) => {
  const router = useRouter()
  const currentSearch = router.asPath.split('?')[1] ?? ''
  const linkUrl = getLinkUrl(link as LinkUrl)

  return (
    <li>
      <TextButton
        fullWidth
        href={link.url}
        size={increaseFontSize ? 'medium' : 'small'}
        target={link.newTab === true ? '_blank' : undefined}
        to={appendSearchParams(linkUrl, currentSearch)}
        variant={variant}
      >
        {link.text}
      </TextButton>
    </li>
  )
}
